import { Table, TableContainer } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
import useTable from "src/hooks/useTable";
import { useGetDemosRequest } from "src/services/admin/queries/demos";

import ContextTable from "./contextTable";
import SkeletonTable from "./SkeletonTable";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import TableNotFound from "./TableNotFound";
import TablePagination from "./TablePagination";

// ----------------------------------------------------------------------

export const DemoTable = () => {
	const control = useTable({
		defaultOrderBy: "lastConnection",
		defaultRowsPerPage: 10,
		defaultDense: true
	});

	const { data, isLoading, isError } = useGetDemosRequest(control.page);

	const empty = data?.items?.length === 0 || isError;

	return (
		<ContextTable.Provider value={{ ...control }}>
			<Scrollbar>
				<TableContainer>
					{isLoading && <SkeletonTable />}
					{!isLoading && data && (
						<Table size='small' sx={{ minWidth: 960 }}>
							<TableHeader />
							<TableBody data={data?.items} />
							{empty && <TableNotFound />}
						</Table>
					)}
				</TableContainer>
				{!empty && <TablePagination count={data?.totalItems ?? 0} />}
			</Scrollbar>
		</ContextTable.Provider>
	);
};

export default DemoTable;
